<template>
  <div
    id="browser"
    class="browser"
    :class="{ fixed: !isCards || fetchingFlats }"
  >
    <transition name="fade">
      <loader
        v-if="fetchingFlats"
        :text="$t('loadingFlats')"
        :spinner="true"
        :zIndex="100"
      ></loader>
    </transition>

    <topbar :class="`${fullClass}`" v-if="topbarVisible"></topbar>
    <breadcrumbs v-if="topbarVisible"> </breadcrumbs>

    <div class="browser__content">
      <div class="browser__main" ref="browser__main" :class="`${fullClass}`">
        <transition :name="routerTransition" mode="out-in">
          <keep-alive include="Building">
            <router-view :key="$route.path" />
          </keep-alive>
        </transition>

        <sidebar v-if="!isFavourite && !isCards"></sidebar>
      </div>
    </div>
    <!-- <logo v-if="!isCards"></logo> -->
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

// Components
import topbar from '@/layout/topbar.vue';
import breadcrumbs from '@/layout/breadcrumbs.vue';
import sidebar from '@/layout/sidebar.vue';
import logo from '@/layout/logo.vue';
import loader from '@/components/loader.vue';

import qs from 'qs';

export default {
  name: 'browser',
  data() {
    return {
      routerTransition: 'fade',
    };
  },
  components: {
    topbar,
    breadcrumbs,
    sidebar,
    logo,
    loader,
  },
  computed: {
    ...mapState({
      fetchingFlats: state => state.browser.fetchingFlats,
      favourites: state => state.browser.favourites,
    }),
    fullClass() {
      let fixedOn = ['investment', 'building', 'login'];
      return fixedOn.includes(this.$route.name) ? 'full' : '';
    },
    isFavourite() {
      return this.$route.name == 'favourites';
    },
    isCards() {
      return this.$route.name == 'cards';
    },
    transparentClass() {
      let transparentOn = ['login'];
      return transparentOn.includes(this.$route.name) ? 'transparent' : '';
    },
    topbarVisible() {
      let invisibleOn = ['login', 'cards'];
      return !invisibleOn.includes(this.$route.name);
    },
  },
  watch: {
    $route(route, oldRoute) {
      if (route.path != oldRoute.path) {
        // Setting up current investment
        if (route.params.investment != oldRoute.params.investment) {
          this.setInvestment(route.params.investment);
        }
        // Transitions
        if (route.name == 'floor' && oldRoute.name == 'floor') {
          this.routerTransition = 'zoom';
        } else if (route.name == 'floor') {
          this.routerTransition = 'zoomin';
        } else {
          this.routerTransition = 'fade';
        }
      }
      // Close favsSidebar
      this.closeFavSidebar();
    },
    favourites() {
      if (!this.isCards) {
        this.passFavourties();
      }
    },
  },
  methods: {
    ...mapActions({
      fetchFavourites: 'FETCH_FAVOURITES',
      setInvestment: 'SET_INVESTMENT',
    }),
    ...mapMutations({
      closeFavSidebar: 'CLOSE_FAV_SIDEBAR',
      addToFavourites: 'ADD_TO_FAVOURITES',
      deleteFromFavourites: 'DELETE_FROM_FAVOURITES',
    }),
    isPassedFlatFavourite(flat) {
      let favs = this.$store.getters.GET_FAVOURITES.map(
        ({ investments_number }) => investments_number
      );

      return favs.includes(flat.investments_number);
    },
    passFavourties() {
      const favouritesFlats = this.favourites.map(
        ({ investments_number }) => investments_number
      );

      this.lastFavourties = this.$store.getters.GET_FAVOURITES;
      window.top.postMessage(favouritesFlats, '*');
    },
    toggleFavourites(flat) {
      if (this.isPassedFlatFavourite(flat)) {
        this.deleteFromFavourites(flat);
      } else {
        this.addToFavourites(flat);
      }
    },
  },
  created() {
    this.fetchFavourites();
    this.passFavourties();

    window.addEventListener('message', e => {
      if (typeof e.data === 'string') {
        if (e.data.includes('TOGGLE_FAVOURITE')) {
          const flat = e.data.split('/')[1];
          const passedFlat = this.$store.getters.GET_FLATS.find(
            ({ investments_number }) => investments_number === flat
          );

          this.toggleFavourites(passedFlat);
        }
      }
    });

    // Setting up current investment
    if (this.$route.params.investment) {
      this.setInvestment(this.$route.params.investment);
    }
  },
};
</script>

<style lang="scss">
.browser {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 400px;
  &.fixed {
    height: 100vh;
    overflow: hidden;
  }
  @media (max-width: 991px) {
    & > nav {
      display: none !important;
    }
  }
}

.browser__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;

  /* @media screen and (max-height: 600px) {
    overflow: auto;
  } */
}

.browser__main {
  flex: 1;
  background: #fff;
  position: relative;
  /* max-height: $fullHeight; */
  @media screen and (min-height: 880px) {
    overflow-y: hidden;
  }
  &.full {
    max-height: $noTopbarHeight;
  }
}

@import '@/styles/customStyles.scss';
</style>
